function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

const AccessContext = require('./contexts/access-context');

function _call(body, then, direct) {
  if (direct) {
    return then ? then(body()) : body();
  }

  try {
    var result = Promise.resolve(body());
    return then ? result.then(then) : result;
  } catch (e) {
    return Promise.reject(e);
  }
}

const assertParam = require('../utils/assertions').assertParamFactory('Ratings');

const fields = ['rating'];

const parse = json => json;

class RatingRepo {
  constructor(client
  /*: ApiClient*/
  , context
  /*: AccessContext*/
  , offerId
  /*: string*/
  ) {
    this.client = client;
    this.context = context;
    this.offerId = offerId;
  }

  buildPath() {
    const {
      propertyId,
      businessId,
      locationId
    } = this.context.serialize();
    assertParam('propertyId', propertyId);
    assertParam('businessId', businessId);
    return [`/properties/${propertyId}`, `/businesses/${businessId}`, locationId ? `/locations/${locationId}` : null, `/offers/search`].filter(s => !!s).join('');
  }

  get()
  /*: Promise<Object>*/
  {
    const _this = this;

    return _call(function () {
      const path = _this.buildPath();

      const params = {
        offerId: _this.offerId
      };
      const req = new _this.client.Request(path, params, fields);
      req.parse = parse;
      return _await(_this.client.get(req), function (result) {
        return result.items[0];
      });
    });
  }

}

module.exports = RatingRepo;